import React from "react";
import { FormattedMessage } from "react-intl.macro";

export const ConfirmationSuccess = (
  <FormattedMessage
    id="invitation.ConfirmationSuccess"
    defaultMessage="Profilo collegato correttamente"
  />
);
export const ConfirmationError = (
  <FormattedMessage
    id="invitation.ConfirmationError"
    defaultMessage="Si è verificato un problema"
  />
);
